export default {
  home: {
    label1: 'English',
    vip: 'Premium', // 开通会员
    Downloadquota: 'Quota', // 下载额度
    Downloadspeed: 'Speed', // 下载加速
    Cloudcapacity: 'Storage', // 云盘空间
    Cloudequity: 'Equity', // 云盘权益
    DownloadLimit: 'Download quota', // 今日下载额度
    awelfarepoint: 'Welfare point', // 福利点
    HelpCentre: 'Help', // 帮助中心
    AccountSettings: 'Settings', // 账号设置
    SignOut: 'Sign Out', // 退出登录
    Login: 'Log in', // 登录
    Signup: 'Sign up', // 注册
    Premium: 'Premium', //开通会员
    PremiumTwo: 'Premium', //升级会员
    PremiumThree: 'Premium', //会员中心
  },
  news: {
    // 信息悬浮框模块
    All: 'All', // 全部
    SystemNotification: 'System', // 系统通知
    OfficialNews: 'Official', // 官方消息
    ReadAll: 'Read All', // 全部已读
    Nonews: 'No news', // 暂无消息
  },
  model:{
    mtext1:'Link uploaded by netizen: ',//该链接由
    mtest2:', does not represent the position of this site',//自行分享，并不代表本站立场
    report:'Report',//举报
    redirectLink:'Redirect Link',//跳转链接
    mtest3:'Click to go to an external site',//点击后将跳转至外部网站
    mtest4:'Short link blocked or deleted—access denied',//该短链已被系统审核过滤或被分享者删除，无法访问
    mtest5:'Reference: ',//参考资料：
    mtest6:'If you have any questions, please visit: ',//如有疑问可访问：
    mtest7:'Short link not found. Check the URL',//未找到短链页面，请检查短链是否正确
    mtest8:'《Feemoo内容审核机制公示》',//《Feemoo内容审核机制公示》
    mtest9:'《Feemoo帮助中心》',//《Feemoo帮助中心》
    mtest10: 'Login redirect', //登录后跳转链接
    mtest11: 'Login and click to open external site', //完成登录点击将跳转至外部网站
    mtest12: 'Mini-Program ad redirect', //去小程序看广告后跳转
    mtest13: 'Watch ad in WeChat Mini Program, then redirect', //点击后前往微信小程序观看广告后将跳转至外部网站
    mtest14: ' App ad redirect', //去APP看广告后跳转
    mtest15: 'Watch ad in App, then redirect', //点击后前往APP观看广告后将跳转至外部网站
    SharedLink:'Shared link',//分享的链接
    UnlockLogin:'Unlock after login',//登录后解锁
    Unlock:'Unlock',//解锁
    Open:'Open',//打开
    mtest16:'Watch mini-program ad after login',//登录后去小程序看广告解锁
    mtest17:'Watch mini-program ad',//去小程序看广告解锁
    mtest18:'Watch Feemoo app ad after login',//登录后去APP看广告解锁
    mtest19:'Watch Feemoo app ad',//去APP看广告解锁
    mtest20:'Unlock after login',//登录后点击解锁
    mtest21:'Click to unlock link',//点击解锁获取链接
  },
  homeFirst: {
    Quicktools: 'Quick tools', // 快捷功能
    Files: 'Files',
    Share: 'Share',
    Set: 'Set',
    DeepSeek: 'DeepSeek',
    Unzip: 'Unzip',
    Transit: 'Transit',
    Record: 'Record',
    Device: 'Device',
    Collect: 'Collect',
    Activity: 'Activity',
    MoreActivity: 'More Activity',
    recycle: 'Recycle Bin', // 回收站
    ShortLink: 'Short Link', // 短链
    ThisMonth: 'This Month',
    LastMonths: 'Last 3 Months',
    DownloadLimit: 'Download quota', // 今日下载额度
    Downloadspeed: 'Speed', // 下载加速
    awelfarepoint: 'Welfare point', // 福利点
    welfare: 'Welfare Agency',// 福利社
  },
}
